// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__O16QC","loading":"Loading_loading__gCn9r"};